(function () {
  if (window.__zzReturnInit) return;
  window.__zzReturnInit = true;

  var st = document.createElement('style');
  st.textContent = ".zz-back-highlight{animation:zz-back-pulse 1.8s ease-out 1}" +
    "@keyframes zz-back-pulse{0%{box-shadow:0 0 0 0 rgba(0,0,0,.18)}35%{box-shadow:0 0 0 6px rgba(0,0,0,.10)}100%{box-shadow:0 0 0 0 rgba(0,0,0,0)}}" +
    "@media (prefers-reduced-motion:reduce){.zz-back-highlight{animation:none}}";
  document.head.appendChild(st);

  var KEY = 'zz-collection-return';
  var GRID = '#product-grid';

  function baseKey() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      return u.pathname + u.search;
    } catch (e) { return window.location.pathname; }
  }

  /* 1. Memoriser la piece consultee au moment du clic */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;
    var grid = document.querySelector(GRID);
    if (!grid || !grid.contains(a)) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    if (!m) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ k: baseKey(), h: m[1], t: Date.now() }));
      /* on prend la main sur le repositionnement du navigateur */
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (err) {}
  }, true);

  /* 2. Revenir sur la piece au retour */
  function restore() {
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;

    var s = null;
    try { s = JSON.parse(raw); } catch (e) { return; }
    if (!s || s.k !== baseKey()) return;
    if (Date.now() - s.t > 1800000) { try { sessionStorage.removeItem(KEY); } catch (e) {} return; }
    try { sessionStorage.removeItem(KEY); } catch (e) {}

    var tries = 0;
    var found = null;

    function place(smooth) {
      if (!found) return;
      var top = found.getBoundingClientRect().top + window.pageYOffset
              - (window.innerHeight / 2) + (found.offsetHeight / 2);
      window.scrollTo(0, Math.max(0, Math.round(top)));
    }

    (function seek() {
      var link = document.querySelector(GRID + ' a[href*="/products/' + s.h + '"]');
      if (link) {
        found = link.closest('product-card') || link;
        place();
        found.classList.add('zz-back-highlight');
        setTimeout(function () { found.classList.remove('zz-back-highlight'); }, 1800);
        /* les images se chargent apres coup et decalent la grille : on repositionne */
        [150, 400, 900, 1600, 2500].forEach(function (d) { setTimeout(place, d); });
        window.addEventListener('load', place);
        setTimeout(function () {
          if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        }, 3000);
        return;
      }
      if (tries >= 15) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
        return;
      }
      tries++;
      var prev = document.querySelector('.js-btn-load-previous');
      if (prev && prev.offsetParent !== null && !prev.hasAttribute('disabled')) {
        prev.click();
        setTimeout(seek, 700);
        return;
      }
      setTimeout(seek, 350);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
})();
